import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=beaaf11e&scoped=true&"
import script from "./MagicLink.vue?vue&type=script&lang=js&"
export * from "./MagicLink.vue?vue&type=script&lang=js&"
import style0 from "./MagicLink.vue?vue&type=style&index=0&id=beaaf11e&prod&lang=css&"
import style1 from "./MagicLink.vue?vue&type=style&index=1&id=beaaf11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaaf11e",
  null
  
)

export default component.exports